import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';
import Events from '../event/';

class ErrorBox extends Component {
    static propTypes = {
        isEndShow: PropTypes.bool,
        replayAction: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            showItem: false,
            isRender: true,
        };
    }
    show = () => {
        this.setState({
            showItem: true,
        });
    };
    hide = () => {
        this.setState({
            showItem: false,
        });
    };

    destroy = () => {
        this.setState({
            isRender: false,
        });
    };

    render() {
        const { showItem, isRender } = this.state;
        const { isEndShow, replayAction } = this.props;

        return isRender ? (
            <div className={styles.videofail} id="js_video_fail" style={{ display: showItem ? 'block' : 'none' }}>
                <div className={styles.videofailLayout}>
                    <div className={styles.videofailText}>亲，播放{isEndShow ? '结束' : '失败'}了</div>
                    <div className={styles.videofailReplay}>
                        <div className={styles.videofailReplayBtn} id="js_videofail_replay">
                            <i />
                            <span onClick={replayAction}>重播</span>
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}
Events.mixTo(ErrorBox);
export default ErrorBox;
